import { connect } from 'react-redux';
import {
  selectDeleteCardState,
  selectDeletePrimaryCardState,
  selectMarkCardPrimaryState,
} from '../../selectors/appState';
import { IStoreState } from '../../types/StoreState';
import { CardsListController } from './controller';

export const CardsListControllerConnect = connect((state: IStoreState) => ({
  markCardPrimaryState: selectMarkCardPrimaryState(state),
  deleteCardState: selectDeleteCardState(state),
  deletePrimaryCardState: selectDeletePrimaryCardState(state),
}))(CardsListController);
